export default __webpack_public_path__ + "static/media/tuyo.b635c697.webp";